/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Store_NameInputs */

const vi_shop_home_store_name = /** @type {(inputs: Shop_Home_Store_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên cửa hàng`)
};

/**

* @param {Shop_Home_Store_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_store_name = /** @type {((inputs?: Shop_Home_Store_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Store_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_store_name(inputs)
});